import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, take, takeUntil, tap } from 'rxjs/operators';
import { AppState } from 'src/app/app.states';
import { AuthActions } from 'src/app/features/authentication/state/auth.action-types';
import { UsersSelectors } from 'src/app/features/users/state/users.selector-types';
import { Roles } from 'src/app/shared/enums/Roles.enum';
import { WindowScrollService } from 'src/app/shared/services/window-scroll.service';
import { SharedActions } from 'src/app/shared/state/shared.action-types';
import { MixpanelService } from './../../../services/mixpanel.service';
import { UsersActions } from 'src/app/features/users/state/users.action-types';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserStatus } from 'src/app/shared/enums/UserStatus.enum';
import { IdType } from 'src/app/shared/enums/IdType.enum';
import { FeatureFlagService } from '../../../services/feature-flag.service';
import {
  InvestorCapabilitiesService,
  MoneyCapabilities,
} from '../../../services/investor-capabilities.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.organism.html',
  styleUrls: ['./side-menu.organism.scss'],
})
export class SideMenuOrganism implements OnInit, OnDestroy {
  isFromInvoice = false;
  profile: any;
  environment = environment;
  menuItems = [
    {
      type: 'link',
      label: 'Operaciones',
      allowedRoles: [
        Roles.ADMIN,
        Roles.SUPER_ADMIN,
        Roles.RISK_ANALYST,
        Roles.CLIENT_HAPPINESS,
        Roles.ACCOUNT_MANGER,
        Roles.ACCOUNT_MANAGER_SUPERVISOR,
        Roles.INVESTOR_SALES,
        Roles.INVESTOR_SALES_SUPERVISOR,
      ],
      target: '/operations',
      imgIcon: 'ops3.svg',
      // fontIconClass: 'icon-invoices'
    },
    {
      type: 'link',
      label: 'Facturas',
      allowedRoles: [
        Roles.ADMIN,
        Roles.SUPER_ADMIN,
        Roles.CLIENT_HAPPINESS,
        Roles.INVESTOR_SALES,
        Roles.INVESTOR_SALES_SUPERVISOR,
        Roles.RISK_ANALYST,
      ],
      target: '/invoices',
      imgIcon: 'invoices.svg',
      // fontIconClass: 'icon-invoices'
    },
    {
      type: 'link',
      label: 'OTD',
      allowedRoles: [Roles.INVESTOR_SALES_SUPERVISOR],
      target: '/otd',
      imgIcon: 'tag.svg',
    },
    {
      type: 'link',
      label: 'Operaciones',
      allowedRoles: [Roles.CLIENT],
      target: '/invoices',
      imgIcon: 'invoices.svg',
      // fontIconClass: 'icon-invoices'
    },
    {
      type: 'link',
      label: 'Oportunidades',
      allowedRoles: [Roles.INVESTOR],
      target: '/opportunities',
      imgIcon: 'opportunities.svg',
      // fontIconClass: 'icon-opportunities',
    },
    {
      type: 'link',
      label: 'Mis inversiones',
      allowedRoles: [Roles.INVESTOR],
      target: '/my-investments',
      imgIcon: 'investments.svg',
      // fontIconClass: 'icon-my-investments'
    },
    {
      type: 'link',
      label: 'Clientes',
      allowedRoles: [Roles.CLIENT],
      target: '/my-clients',
      imgIcon: 'my-clients.svg',
    },
    {
      type: 'link',
      label: 'Proveedores',
      allowedRoles: [Roles.CLIENT],
      target: '/my-suppliers',
      imgIcon: 'my-supliers.svg',
    },
    {
      type: 'link',
      label: 'Cuentas bancarias',
      allowedRoles: [Roles.CLIENT],
      target: '/bank-accounts',
      imgIcon: 'bank-accounts.svg',
      // fontIconClass: 'icon-bank-accounts'
    },
    {
      type: 'link',
      label: 'Cuentas bancarias',
      allowedRoles: [Roles.INVESTOR],
      target: '/bank-accounts',
      imgIcon: 'bank-accounts.svg',
      // fontIconClass: 'icon-bank-accounts'
    },
    {
      type: 'section-message',
      label: 'Conecta tu cuenta SUNAT',
      text: 'Mejora tus condiciones con nosotros',
      allowedRoles: [Roles.CLIENT],
      target: '',
    },
    {
      type: 'link',
      label: 'Respuestas deudor',
      allowedRoles: [Roles.ADMIN, Roles.SUPER_ADMIN],
      target: '/debtor-replies',
      imgIcon: 'email-sended.svg',
    },
    {
      type: 'link',
      label: 'Transacciones financieras',
      allowedRoles: [
        Roles.ADMIN,
        Roles.SUPER_ADMIN,
        Roles.INVESTOR,
        Roles.INVESTOR_SALES,
        Roles.INVESTOR_SALES_SUPERVISOR,
      ],
      target: '/financial-transactions',
      imgIcon: 'transactions.svg',
      // fontIconClass: 'icon-financial-transactions'
    },
    {
      type: 'link',
      label: 'Ajustes del sistema',
      allowedRoles: [Roles.ADMIN, Roles.SUPER_ADMIN],
      target: '/system-settings',
      imgIcon: 'settings.svg',
      // fontIconClass: 'icon-system-settings'
    },
    {
      type: 'link',
      label: 'Cuentas de Usuarios',
      allowedRoles: [Roles.ADMIN, Roles.SUPER_ADMIN],
      target: '/users-accounts',
      imgIcon: 'my-clients.svg',
      // fontIconClass: 'icon-user-accounts'
    },
    // {
    //   type: 'link',
    //   label: 'Pendientes',
    //   allowedRoles: [Roles.RISK_ANALYST],
    //   target: '/risk-pending-evaluations',
    //   imgIcon: 'opportunities.svg',
    // },
    {
      type: 'link',
      label: 'Pagadores',
      allowedRoles: [Roles.RISK_ANALYST, Roles.ACCOUNT_MANGER, Roles.ACCOUNT_MANAGER_SUPERVISOR],
      target: '/risk-debtors',
      imgIcon: 'my-clients.svg',
    },
    {
      type: 'separator',
      allowedRoles: [
        Roles.ADMIN,
        Roles.SUPER_ADMIN,
        Roles.INVESTOR,
        Roles.CLIENT,
        Roles.RISK_ANALYST,
        Roles.CLIENT_HAPPINESS,
        Roles.ACCOUNT_MANGER,
        Roles.ACCOUNT_MANAGER_SUPERVISOR,
        Roles.INVESTOR_SALES,
        Roles.INVESTOR_SALES_SUPERVISOR,
      ],
    },
    {
      type: 'feedback',
      label: 'Feedback',
      allowedRoles: [Roles.CLIENT, Roles.INVESTOR],
      target: '',
      imgIcon: 'feedback-icon.svg',
    },
    {
      type: 'newTab',
      label: 'Preguntas frecuentes',
      allowedRoles: [Roles.CLIENT, Roles.INVESTOR],
      target: 'https://ayuda.finsmart.pe/es/',
      imgIcon: 'repeated-questions.svg',
    },
    {
      type: 'link',
      label: 'Mis datos personales',
      allowedRoles: [
        Roles.CLIENT,
        Roles.ADMIN,
        Roles.SUPER_ADMIN,
        Roles.INVESTOR,
        Roles.RISK_ANALYST,
        Roles.CLIENT_HAPPINESS,
        Roles.ACCOUNT_MANGER,
        Roles.ACCOUNT_MANAGER_SUPERVISOR,
        Roles.INVESTOR_SALES,
        Roles.INVESTOR_SALES_SUPERVISOR,
      ],
      target: '/profile-settings',
      imgIcon: 'my-profile.svg',
      // fontIconClass: 'icon-profile'
    },
    {
      type: 'button',
      label: 'Cerrar sesión',
      allowedRoles: [
        Roles.ADMIN,
        Roles.SUPER_ADMIN,
        Roles.INVESTOR,
        Roles.CLIENT,
        Roles.RISK_ANALYST,
        Roles.CLIENT_HAPPINESS,
        Roles.ACCOUNT_MANGER,
        Roles.ACCOUNT_MANAGER_SUPERVISOR,
        Roles.INVESTOR_SALES,
        Roles.INVESTOR_SALES_SUPERVISOR,
      ],
      imgIcon: 'logout.svg',
      // fontIconClass: 'icon-logout',
      action: AuthActions.ManualLogOut,
    },
  ];
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private mixpanelService: MixpanelService,
    private windowScrollService: WindowScrollService,
    private featureFlagService: FeatureFlagService,
    private investorCapabilities: InvestorCapabilitiesService
  ) {}
  removedItem;

  ngOnInit() {
    this.windowScrollService.previousUrl$.subscribe((previousUrl: string) => {
      // console.log('previous url: ', previousUrl);
      if (previousUrl === '/invoices') {
        this.isFromInvoice = true;
      }
    });

    this.store.dispatch(UsersActions.LoadProfile());

    this.store
      .select(UsersSelectors.profile())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(profile => {
        if (profile) {
          this.profile = profile;
        }
      });

    this.store
      .select(UsersSelectors.profile())
      .pipe(first(p => p?.isThirdPartyAM))
      .subscribe(userProfile => {
        if (userProfile?.isThirdPartyAM) {
          this.removedItem = this.menuItems.splice(
            (this.removedItem = this.menuItems.findIndex(item => item.label === 'Pagadores')),
            1
          );
        }
        // else {
        //   if (this.removedItem) {
        //     this.menuItems.push(this.removedItem);
        //     this.removedItem = null;
        //   }
        // }
      });
  }

  clicked(payload, item) {
    if (this.isItemDisabled(item)) {
      payload.preventDefault();
      return;
    }

    if (this.router.url !== payload.target) {
      switch (payload.type) {
        case 'link':
          this.router.navigateByUrl(payload.target);
          break;
        case 'button':
          this.store.dispatch(payload.action());
          break;
      }
    } else {
      this.store.dispatch(SharedActions.HideSideMenu());
    }

    this.store.dispatch(SharedActions.HideToggleMenu());

    this.mixpanelService.newEvent('Side Menu', { $option: item.label });
    this.removeLocalStorage();
  }

  isActive(target) {
    // console.log('target', this.router.url.split('/'));
    let routeLength = this.router.url.split('/')?.length;
    const activeRoute = '/' + this.router.url.split('/')[1];
    let activeRouteWithoutQuery = activeRoute.split('?')[0];
    activeRouteWithoutQuery = activeRoute.split('#')[0];
    if (activeRouteWithoutQuery === '/invoices' && routeLength > 2) {
      if (this.isFromInvoice && target === '/invoices') {
        return 'active';
      }
      if (!this.isFromInvoice && target === '/operations') {
        return 'active';
      }
    } else {
      return activeRouteWithoutQuery === target ? 'active' : '';
    }
  }

  hideMenu() {
    this.store.dispatch(SharedActions.HideSideMenu());
  }

  removeLocalStorage() {
    localStorage.removeItem('tab_transactions');
    localStorage.removeItem('tab_opportunities_pen');
    localStorage.removeItem('tab_opportunities_usd');
    localStorage.removeItem('tab_operation_detail');
    localStorage.removeItem('productTourStart');
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  isMenuItemVisible(item: any): boolean {
    if (item.showFlag && !(this.environment.name === 'development' || this.environment.name === 'staging')) {
      return false;
    }

    if (
      item.type === 'section-message' &&
      (!this.featureFlagService.isFaproEnabled() ||
        this.profile?.faproRegistered ||
        this.profile?.role === !Roles.CLIENT)
    ) {
      return false;
    }

    if (item.target === '/otd' && !this.featureFlagService.isOtdFundInvoiceSaleEnabled()) {
      return false;
    }

    return true;
  }

  // FIN-1709 · AC1 and AC3. The item is greyed *and* inert — `clicked()` calls
  // `preventDefault()` before anything else — so both criteria turn on this one answer.
  isItemDisabled(item: any): boolean {
    const itemCapabilities: { [target: string]: (keyof MoneyCapabilities)[] } = {
      '/bank-accounts': ['bankAccount'],
      // The section holds deposit and retiro both; either one open keeps it reachable.
      '/financial-transactions': ['deposit', 'withdraw', 'donate', 'invest'],
    };

    const required = itemCapabilities[item.target];

    // Only an inversionista was ever greyed out here, and only these two items.
    if (required === undefined || this.profile?.role !== Roles.INVESTOR) {
      return false;
    }

    const capabilities = this.investorCapabilities.capabilitiesFor(this.profile);

    return !required.some(capability => capabilities[capability]);
  }
}
